import { useEffect, useLayoutEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { fileUrl, language, useFETCH } from "../../Tools/APIs";
import { Col, Row } from "../../Tools/Grid-system";
import Pagination from "../../Tools/Pagination";
import { Promotion } from "../../components";
import { content } from "../../Context/translate";
import Loading from "../../Tools/Loading";
import { Filter } from "lucide-react"; 

function Blog() {
  const { data, isLoading } = useFETCH("v1/blog/sections?paginate=0");
  const [idBlog, setIdBlog] = useState(null);
  const [searchKey, setSearchKey] = useState("");
  const [debouncedSearchKey, setDebouncedSearchKey] = useState("");
  const [showFilter, setShowFilter] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearchKey(searchKey);
    }, 500);
    return () => clearTimeout(timer);
  }, [searchKey]);

  if (isLoading) return <Loading />;

  return (
    <Col md={11} className="mx-auto ">
      <>
        <h1 className="font-bold text-3xl text-Secondary mt-12 mb-12">
          {content.Categories}
        </h1>

        <div className="relative flex items-center gap-3 w-full max-w-md mx-auto mb-8">
          <input
            type="text"
            placeholder={content.SearchBlogs}
            value={searchKey}
            className="w-full px-4 py-2 rounded-md border border-Main focus:outline-none focus:ring-2 focus:ring-Main focus:border-transparent"
            onChange={(e) => setSearchKey(e.target.value)}
          />
          <button
            onClick={() => setShowFilter(!showFilter)}
            className="p-2 rounded-md border border-Main hover:bg-Main hover:text-white transition"
          >
            <Filter size={20} />
          </button>
          {showFilter && (
          <div className="absolute top-12 right-0 w-full
                bg-white border border-gray-200 rounded-lg shadow-lg z-10">
              <ul className="max-h-64 overflow-y-auto">
                <li
                  onClick={() => {
                    setIdBlog(null);
                    setShowFilter(false); 
                  }}
                  className={`px-4 py-2 cursor-pointer hover:bg-Main hover:text-white transition ${
                    idBlog === null ? "bg-Main text-white" : ""
                  }`}
                >
                  جميع الأقسام
                </li>
                {data?.data?.data?.map((e) => (
                  <li
                    key={e.id}
                    onClick={() => {
                      setIdBlog(e.id);
                      setShowFilter(false); 
                    }}
                    className={`px-4 py-2 cursor-pointer hover:bg-Main hover:text-white transition ${
                      idBlog === e.id ? "bg-Main text-white" : ""
                    }`}
                  >
                    {e.name}
                  </li>
                ))}
              </ul>
            </div>
          )}
        </div>
      </>
      <Posts
        sectionId={idBlog}
        searchKey={debouncedSearchKey}
        setSearchKey={setSearchKey}
      />
      <Promotion />
    </Col>
  );
}
export default Blog;

const Posts = ({ sectionId, searchKey = "", setSearchKey }) => {
  const location = useLocation();
  const searchSlug = location.state?.searchSlug;

  useLayoutEffect(() => {
    setSearchKey(searchSlug);
  }, [searchSlug]);

  const { data, isLoading } = useFETCH(
    `v1/blog/posts?lang=${language}${
      sectionId ? "&section_id=" + sectionId : ""
    }${searchKey ? "&tags=" + searchKey : ""}`
  );

  function replaceSpacesWithUnderscore(str) {
    return str.replace(/ /g, "_");
  }

  return (
    <Pagination >
      <Row justify={"start"}>
        {isLoading ? (
          <>
            <Col md={4} xs={6}>
              <div className="rounded-lg h-[260px] bg-slate-200 animate-pulse" />
            </Col>
            <Col md={4} xs={6}>
              <div className="rounded-lg h-[260px] bg-slate-200 animate-pulse" />
            </Col>
            <Col md={4} xs={6}>
              <div className="rounded-lg h-[260px] bg-slate-200 animate-pulse" />
            </Col>
          </>
        ) : (
          data?.data?.data?.map((e) => (
           <Col key={e.id}  xl={4} md={6} sm={12} xs={12} className="px-2 mb-6">

              <div className="rounded-2xl shadow-md shadow-Main w-full overflow-hidden hover:scale-105 transition-all">
                <div className="h-[220px] w-full">
                  <img
                    src={fileUrl + e.image}
                    alt=""
                    className="w-full h-full object-cover"
                  />
                </div>
                <p className="font-semibold md:text-md text-black my-3 px-2 text-center line-clamp-2 h-[56px]">
                  {e.title.length > 50
                    ? e.title.substring(0, 60) + "..."
                    : e.title}
                </p>
                <div className="text-end p-2">
                  <Link
                    to={`/blog/${replaceSpacesWithUnderscore(e.title)}`}
                    state={{ postId: e.id }}
                  >
                    <span className="text-Secondary text-sm font-bold underline">
                      {content.ReadMore}
                    </span>
                  </Link>
                </div>
              </div>
            </Col>
          ))
        )}
      </Row>
    </Pagination>
  );
};
